/**
 * @ngdoc Controller
 * @name ActivityFeedController
 */
import { localeMeta } from "@/languages/meta";
import { findAccessLevelOption } from "@/vue/store/modules/installation-access-level.js"

(function () {
    "use strict";

    angular
        .module("vrm.core")
        .controller("AdminUsersController", AdminUsersController)
        .controller("AdminUsersFormController", AdminUsersFormController)
        .controller("AdminUsersDetailController", AdminUsersDetailController);

    /**
     * @constructor
     * @ngInject
     */
    function AdminUsersDetailController(
        $log,
        $state,
        $scope,
        ApiService,
        $stateParams
    ) {
        $log.info("AdminUsersDetailController");

        $scope.user = null;
        $scope.installations = [];
        $scope.loading = true;

        ApiService.call(
            "/users/" + $stateParams.id + "/installations?extended=1"
        ).then(function (response) {
            var rawInstallations = response.data.records;
            ApiService.admin("installations", {
                "filter[idUser]": $stateParams.id,
                count: 2000
            }).then(function (response) {
                $scope.installations = rawInstallations;
                $scope.loading = false;
                _.each($scope.installations, function (installation, key) {
                    $scope.installations[key].admin_data = _.find(
                        response.data.records,
                        function (record) {
                            return record.id == installation.idSite;
                        }
                    );
                    $scope.installations[key].accessLevelName = findAccessLevelOption($scope.installations[key].accessLevel).name
                });
            });
        });

        ApiService.admin("users", { "filter[idUser]": $stateParams.id }).then(
            function (response) {
                // Check if no record is found, if so return to browse
                if (response.data.num_records < 1)
                    $state.go("base.admin.users");

                // Set on scope
                $scope.user = response.data.records[0];
            }
        );
    }

    /**
     * @constructor
     * @ngInject
     */
    function AdminUsersController(
        $timeout,
        $log,
        $state,
        UserService,
        $scope,
        $interval,
        AdminTableService,
        GraphService,
        ApiService,
        locale,
        vrmNotificationsService,
        vrmNotificationType,
        VrmModalService,
        localStorageService,
        $location,
        $window,
        vrmUserAccessLevel
    ) {
        $log.info("AdminUserController");
        $scope.searchModel = { value: "" };
        $scope.isImpersonatedUser = localStorageService.get('adminToken');
        $scope.isAdmin = false;
        $scope.visible = {};

        var endPoint = function (params) {
            if ($scope.searchModel.value && $scope.searchModel.value != "") {
                params.q = $scope.searchModel.value;
            }
            return ApiService.admin("users", params);
        };

        $scope.table = new AdminTableService(endPoint);

        UserService.getUser().then(function (user) {
            $scope.isAdmin = user.accessLevel === vrmUserAccessLevel.ADMIN;
        });

        $scope.getAccessLevel = function (accessLevel) {
            var res = "";
            _.each(vrmUserAccessLevel, function (val, key) {
                if (val == accessLevel) res = key;
            });
            return res.toLocaleLowerCase().replace("_", " ");
        };

        var endPoint = function (params) {
            if ($scope.searchModel.value && $scope.searchModel.value != "") {
                params.q = encodeURIComponent($scope.searchModel.value);
            }
            return ApiService.admin("users", params);
        };

        $scope.table = new AdminTableService(endPoint);

        // Trigger free search
        $scope.searchTimeout = null;
        $scope.$watch("searchModel.value", function (val) {
            if (val && val != "") {
                $timeout.cancel($scope.searchTimeout);
                $scope.searchTimeout = $timeout(function () {
                    $scope.table.params.reload();
                }, 500);
            }
        });

        GraphService.ready().then(function () {
            $scope.chart = {
                size: {
                    height: 200
                },
                options: {},
                xAxis: {
                    categories: [
                        "Jan",
                        "Feb",
                        "Mar",
                        "Apr",
                        "May",
                        "Jun",
                        "Jul",
                        "Aug",
                        "Sep",
                        "Oct",
                        "Nov",
                        "Dec"
                    ]
                },
                yAxis: {
                    title: {
                        text: locale.getString("admin.chart_new_users_title")
                    }
                },
                chart: {
                    zoomType: "x",
                    marginTop: 45
                },
                tooltip: {
                    shared: true,
                    animation: false,
                    headerFormat: ""
                },
                title: {
                    text: ""
                },
                subtitle: {
                    text: ""
                },
                legend: {
                    enabled: true
                },
                credits: {
                    enabled: false
                },
                series: [],
                loading: true
            };
            ApiService.call("/admin/user-stats/").then(function (response) {
                $scope.chart.series = response.data.series;
                $scope.chart.loading = false;
            });
        });

        $scope.remove = function (id) {
            VrmModalService.openConfirmModal($scope, "delete", function (
                confirmed
            ) {
                if (confirmed && id) {
                    ApiService.admin("users/" + id, {}, "DELETE").then(
                        function () {
                            locale.ready("admin").then(function () {
                                vrmNotificationsService.add({
                                    type: vrmNotificationType.SUCCESS,
                                    message: locale.getString(
                                        "admin.user_deleted"
                                    )
                                });
                                $scope.table.params.reload();
                            });
                        }
                    );
                }
            });
        };

        $scope.impersonate = function (id) {
            ApiService.call("/auth/generateImpersonationToken", {
                idUser: id
            }).then(function (response) {
                if (response.data.success && response.data.token) {
                    localStorageService.set(
                        "adminToken",
                        localStorageService.get("token")
                    );
                    localStorageService.set(
                        "login.impersonationToken",
                        response.data.token
                    );
                    $state.go("login");
                }
            });
        };

        $scope.canImpersonate = function (impersonateeAccessLevel) {
            const impersonatorAccessLevel = $scope.user.accessLevel;
            return (
                !$scope.isImpersonatedUser &&
                !(impersonateeAccessLevel === vrmUserAccessLevel.ADMIN) &&
                !(
                    impersonatorAccessLevel ===
                    vrmUserAccessLevel.RESTRICTED_ADMIN &&
                    impersonateeAccessLevel ===
                    vrmUserAccessLevel.RESTRICTED_ADMIN
                )
            );
        };
    }

    /**
     * @constructor
     * @ngInject
     */
    function AdminUsersFormController(
        vrmUserAccessLevel,
        $log,
        $rootScope,
        $scope,
        $stateParams,
        ApiService,
        UserService,
        $state,
        vrmNotificationsService,
        locale,
        vrmNotificationType,
        $q
    ) {
        $log.info("AdminUsersFormController");
        $scope.errors = {};
        var browseState = "base.admin.users";

        // Select options
        $scope.languages = [
            { id: null, name: "Select language" },
            ...localeMeta
                .languagesMainFirst()
                .map(item => ({ id: item.code, name: item.label }))
        ];

        $scope.accessLevels = [
            { id: null, name: "Select an access level" },
            { id: vrmUserAccessLevel.DEMO, name: "Demo" },
            { id: vrmUserAccessLevel.USER, name: "User" },
            { id: vrmUserAccessLevel.ADMIN, name: "Admin" },
            {
                id: vrmUserAccessLevel.RESTRICTED_ADMIN,
                name: "Restricted admin"
            },
            { id: vrmUserAccessLevel.DEALER, name: "Dealer" },
            { id: vrmUserAccessLevel.AUTOMATION, name: "Automation" }
        ];

        // Get the currentUser object
        UserService.getUser().then(function (user) {
            $scope.currentUser = user;
            //If the user is a restricted admin, remove "Admin" from the accessLevel array
            if (
                $scope.currentUser.accessLevel ==
                vrmUserAccessLevel.RESTRICTED_ADMIN
            ) {
                for (var i = 0; i < $scope.accessLevels.length; i++) {
                    if ($scope.accessLevels[i].id == vrmUserAccessLevel.ADMIN) {
                        $scope.accessLevels.splice(i, 1);
                        break;
                    }
                }
            }
        });

        $scope.whitelabels = [{ id: null, name: "Use VRM dealer whitelabel" }];
        $scope.dealers = [{ id: null, name: "No VRM dealer" }];

        // Default user
        $scope.user = {
            selected_whitelabel: $scope.whitelabels[0],
            selected_dealer: $scope.dealers[0],
            selected_accessLevel: $scope.accessLevels[0],
            selected_language: $scope.languages[0]
        };
        $scope.editing = $stateParams.id ? true : false;

        // Get whitelabels and dealers + parse user to scope
        $q.all([
            ApiService.call("/admin/whitelabels", {}, "GET"),
            ApiService.call("/admin/dealers", {}, "GET")
        ]).then(function (responses) {
            var whitelabels = responses[0];
            var dealers = responses[1];

            $scope.whitelabels = $scope.whitelabels.concat(
                whitelabels.data.records
            );
            $scope.dealers = $scope.dealers.concat(dealers.data.records);

            // Retrieve users
            if ($stateParams.id) {
                ApiService.admin("users", {
                    "filter[idUser]": $stateParams.id
                }).then(function (response) {
                    // Check if no record is found, if so return to browse
                    if (response.data.num_records < 1) $state.go(browseState);

                    // Set on scope
                    $scope.user = parse(response.data.records[0]);
                });
            }
        });

        function parse(user) {
            var res = _.clone(user);
            res.name = user.name;
            res.allowLogin = user.allowLogin == 1;
            res.selected_whitelabel = _.find($scope.whitelabels, function (
                record
            ) {
                return record.id == user.idWhiteLabel;
            });
            res.selected_dealer = _.find($scope.dealers, function (record) {
                return record.id == user.idDealer;
            });
            res.selected_accessLevel = _.find($scope.accessLevels, function (
                record
            ) {
                return record.id == user.accessLevel;
            });
            res.selected_language = _.find($scope.languages, function (record) {
                return record.id == user.language;
            });
            return res;
        }

        $scope.doSave = function () {
            // Gather data
            var data = _.clone($scope.user);

            data.idWhiteLabel = data.selected_whitelabel.id;
            data.idDealer = data.selected_dealer.id;
            if (data.selected_accessLevel != null) {
                data.accessLevel = data.selected_accessLevel.id;
            }
            data.language = data.selected_language.id;
            data.allowLogin = data.allowLogin ? 1 : 0;

            delete data["selected_whitelabel"];
            delete data["selected_dealer"];
            delete data["selected_accessLevel"];
            delete data["selected_language"];

            // Save
            ApiService.admin(
                "users/" + ($scope.editing ? $stateParams.id : ""),
                data,
                $scope.editing ? "PUT" : "POST",
                true
            ).then(function (response) {
                if (response.data.success) {
                    locale.ready("admin").then(function () {
                        vrmNotificationsService.add({
                            type: vrmNotificationType.SUCCESS,
                            message: locale.getString("admin.user_saved")
                        });
                        $state.go(browseState);
                    });
                } else {
                    $scope.errors = response.data.errors;
                    let message = [];
                    if (Array.isArray(response.data.errors)) {
                        message = response.data.errors;
                    }
                    else {
                        const fields = Object.keys(response.data.errors);
                        for (let field of fields) {
                            message.push(
                                `${field}: ${response.data.errors[field]}`
                            );
                        }
                    }
                    message = message.join("<br />");
                    vrmNotificationsService.add(
                        { type: vrmNotificationType.ERROR, message },
                        true
                    );
                }
            });
        };

        $scope.clearError = function (tag) {
            if ($scope.errors[tag]) {
                delete $scope.errors[tag];
            }
        };
    }
})();
